"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reselect = require("reselect");
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _AuInput = _interopRequireDefault(require("./AuInput"));
var _context2, _context3, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const input_height_desktop = 48;
var styles = {
  "container": "au_drop_down-module__container___pdeCN",
  "selection": "au_drop_down-module__selection___RwRai",
  "toggle": "au_drop_down-module__toggle___RCTEY",
  "active": "au_drop_down-module__active___fYtq7",
  "disabled": "au_drop_down-module__disabled___Yzzde",
  "mimic": "au_drop_down-module__mimic___muphi",
  "input": "au_drop_down-module__input___VRcs3",
  "shifted": "au_drop_down-module__shifted___Vjy2b",
  "padded": "au_drop_down-module__padded____rLU5",
  "options": "au_drop_down-module__options___uW09z",
  "above": "au_drop_down-module__above___qDmpN",
  "below": "au_drop_down-module__below___OeHcc",
  "option": "au_drop_down-module__option___w7XqX",
  "selected": "au_drop_down-module__selected___FmaYI",
  "subTitle": "au_drop_down-module__subTitle___VAJcg",
  "subtitle": "au_drop_down-module__subtitle___km2lt"
};
const optionSpec = {
  className: T.string,
  displayId: T.string,
  displayString: T.string,
  onClick: T.func
};
const getSortedOptions = (0, _reselect.createSelector)([args => args.options, args => args.intl, args => args.disableSort], (options, intl, disableSort = false) => {
  let optionsArr;
  // make sure options is an Array
  if ((0, _isArray.default)(options)) {
    optionsArr = [...options];
  } else {
    var _context;
    optionsArr = (0, _map.default)(_context = (0, _entries.default)(options)).call(_context, ([val, props]) => (0, _assign.default)({
      val
    }, props));
  }
  // localize if displayId is specified
  optionsArr = (0, _map.default)(optionsArr).call(optionsArr, option => {
    if (option.displayId) {
      return {
        ...option,
        displayString: intl.formatMessage({
          id: option.displayId,
          ...options
        })
      };
    }
    return option;
  });
  if (disableSort) {
    return optionsArr;
  }

  // sort by displayString
  return (0, _sort.default)(optionsArr).call(optionsArr, (a, b) => b.displayString > a.displayString ? -1 : a.displayString > b.displayString ? 1 : 0);
});
const getSelectedOption = (0, _reselect.createSelector)([args => args.options, args => args.selection], (options, selection) => {
  let selected;
  (0, _forEach.default)(options).call(options, option => {
    if (selection === option.val) {
      selected = option;
      return;
    }
  });
  return selected;
});
const getSuggestedOptions = (0, _reselect.createSelector)([getSortedOptions, args => (0, _filter.default)(args)], (options, filter) => (0, _filter.default)(options).call(options, v => filter !== '' && v.displayString?.toLowerCase().includes(filter?.toLowerCase()) || v.subTitle?.toLowerCase().includes(filter?.toLowerCase())));
const Toggle = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement("div", {
  ref: ref,
  className: (0, _classnames.default)(styles.toggle, {
    [styles.active]: props.active,
    [styles.disabled]: props.disabled
  }, props.className),
  onClick: !props.disabled ? props.onClick : _constants.NOOP
}));
const Li = ({
  children,
  className,
  title,
  onClick
}) => /*#__PURE__*/_react.default.createElement("li", {
  className: className,
  title: title,
  onClick: onClick
}, children);
class Ul extends _react.default.Component {
  static propTypes = {
    selectOption: T.func.isRequired,
    options: T.array.isRequired,
    userEntry: T.oneOfType([T.number, T.string]),
    selection: T.oneOfType([T.string, T.number]),
    initialSelection: T.string,
    className: T.string,
    max: T.number,
    disableSort: T.bool,
    maxOptionsHeight: T.number
  };
  static getDerivedStateFromProps(props, state) {
    const {
      userEntry,
      selection,
      options,
      intl,
      disableSort
    } = props;
    if (userEntry !== state.userEntry) {
      const sortedOptions = getSortedOptions({
        options,
        intl,
        disableSort
      });
      const selectedIndex = (0, _findIndex.default)(sortedOptions).call(sortedOptions, ({
        displayString
      }) => displayString === selection);
      if (selectedIndex !== state.selectedIndex) {
        return {
          selectedIndex,
          userEntry
        };
      }
      return {
        userEntry
      };
    }
    return null;
  }
  state = {
    selectedIndex: -1
  };
  listRef = /*#__PURE__*/_react.default.createRef();
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, true);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, true);
  }
  onKeyDown = (0, _bind.default)(_context2 = this.onKeyDown).call(_context2, this);
  onKeyDown(e) {
    const {
      options,
      selectOption
    } = this.props;
    const {
      selectedIndex
    } = this.state;
    switch (e.key) {
      case _constants.UP_KEY:
        // Up
        this.moveSelection(-1);
        e.preventDefault();
        break;
      case _constants.DOWN_KEY:
        // Down
        this.moveSelection(1);
        e.preventDefault();
        break;
      case _constants.ENTER_KEY:
        // Enter
        if (selectedIndex !== -1) {
          selectOption(options[selectedIndex]);
          e.stopPropagation(); // Prevent enter from entering partial search
        }

        break;
      default:
        break;
    }
  }
  moveSelection(delta) {
    const {
      max,
      options
    } = this.props;
    this.setState(prevState => ({
      selectedIndex: (0, _clamp.default)(prevState.selectedIndex + delta, 0, Math.min(max, options.length) - 1)
    }));
  }
  isBelow() {
    const {
      bufferTop,
      bufferBottom,
      containerRef
    } = this.props;
    const container = containerRef.current.getBoundingClientRect();
    const formEl = this.listRef.current ? this.listRef.current.closest('form') : null;
    const [topOffset, bottomOffset] = formEl ? [formEl.getBoundingClientRect().top, 106] : /* height of entity title and field buttons */
    [bufferTop, bufferBottom]; /* default height of nav and footer */

    const maxHeightAbove = container.top - topOffset;
    const maxHeightBelow = window.innerHeight - container.bottom - bottomOffset;
    return [Math.max(maxHeightBelow, maxHeightAbove), maxHeightBelow > maxHeightAbove];
  }
  render() {
    const {
      options,
      selectOption,
      max,
      className,
      maxOptionsHeight,
      hint
    } = this.props;
    const {
      selectedIndex
    } = this.state;
    const [maxHeight, isBelow] = this.isBelow();
    const listItems = [];
    for (let i = 0, len = options.length; i < max && i < len; i++) {
      const option = options[i];
      listItems.push( /*#__PURE__*/_react.default.createElement(Li, {
        key: option.val,
        className: (0, _classnames.default)(styles.option, {
          [styles.selected]: i === selectedIndex,
          [styles.subTitle]: option.subTitle
        }, option.className),
        title: option.displayString,
        subtitle: option.subTitle,
        onClick: () => selectOption(option)
      }, option.displayString, option.subTitle && /*#__PURE__*/_react.default.createElement("div", {
        className: styles.subtitle
      }, option.subTitle)));
    }
    listItems.push(hint);
    const classes = (0, _classnames.default)('o-list-bare', styles.options, isBelow ? styles.below : styles.above, className);
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: classes,
      ref: this.listRef,
      style: {
        maxHeight: maxOptionsHeight * input_height_desktop || maxHeight
      }
    }, listItems);
  }
}
class AuDropDown extends _react.default.Component {
  static propTypes = {
    options: T.oneOfType([T.objectOf(T.shape(optionSpec)), T.arrayOf(T.shape({
      val: T.oneOfType([T.string, T.number]).isRequired,
      ...optionSpec
    }))]),
    selection: T.oneOfType([T.string, T.number]),
    selectOption: T.func.isRequired,
    // Callback for user select and typed entry
    onChange: T.func,
    createMode: T.bool,
    className: T.string,
    toggleClassName: T.string,
    selectionClassName: T.string,
    optionsClassName: T.string,
    maxOptions: T.number,
    // Number of suggested options shown when typing
    placeholder: T.oneOfType([T.number, T.string]),
    placeholderId: T.string,
    expandedPlaceholder: T.string,
    expandedPlaceholderId: T.string,
    allowTyping: T.bool,
    showError: T.bool,
    error: T.object,
    bufferTop: T.number,
    bufferBottom: T.number,
    disableSort: T.bool,
    maxOptionsHeight: T.number,
    defaultValue: T.any,
    hideToggle: T.bool,
    filterSuggestedOptions: T.bool,
    showSubTitle: T.bool,
    showClear: T.bool
  };
  static defaultProps = {
    allowTyping: false,
    onChange: _constants.NOOP,
    bufferTop: 54,
    bufferBottom: 0,
    disableSort: false,
    maxOptionsHeight: 7,
    hideToggle: false,
    filterSuggestedOptions: false,
    showSubTitle: false,
    showClear: true
  };
  inputRef = /*#__PURE__*/_react.default.createRef();
  toggleRef = /*#__PURE__*/_react.default.createRef();
  containerRef = /*#__PURE__*/_react.default.createRef();
  static getDerivedStateFromProps(props, state) {
    if (props.selection !== state.selection) {
      const userEntry = AuDropDown.getUserEntry(props);
      if (userEntry !== state.userEntry) {
        return {
          userEntry
        };
      }
    }
    return false;
  }
  static getUserEntry(props) {
    const options = getSortedOptions({
      options: props.options,
      intl: props.intl,
      disableSort: props.disableSort
    });
    const selectedOption = getSelectedOption({
      options,
      selection: props.selection
    });
    return selectedOption && (selectedOption.subTitle || selectedOption.displayString) || props.allowTyping && props.selection || '';
  }
  constructor(props) {
    super(props);
    this.state = {
      selection: props.selection,
      userEntry: AuDropDown.getUserEntry(props) || props.defaultValue,
      expanded: false
    };

    /*
      Object is deprecated because it cannot guarantee the order of the items,
      which may be important.
     */
    if (!(0, _isArray.default)(props.options)) {
      /* eslint-disable no-console */
      console.warn('"options" property of type Object has been deprecated. ' + 'Please update your code to supply an Array instead.');
      /* eslint-enable no-console */
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handlePageKeyDown);
    window.addEventListener('mousedown', this.handlePageClick);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handlePageKeyDown);
    window.removeEventListener('mousedown', this.handlePageClick);
  }
  handlePageKeyDown = (0, _bind.default)(_context3 = this.handlePageKeyDown).call(_context3, this);
  handlePageKeyDown(e) {
    var _context4;
    const {
      expanded
    } = this.state;

    // Close expansion if we are typing anywhere else than our input
    // Ignore Delete, Backspace, Up, Down and Enter
    if (expanded && !(0, _includes.default)(_context4 = [_constants.DELETE_KEY, _constants.DOWN_KEY, _constants.UP_KEY, _constants.ENTER_KEY, _constants.BACKSPACE_KEY]).call(_context4, e.key)) {
      this.toggleExpanded();
    }
  }

  // TODO: check if we need to attach touch events
  handlePageClick = (0, _bind.default)(_context5 = this.handlePageClick).call(_context5, this);
  handlePageClick() {
    if (this.mouseIsDownOnOptions) return;
    if (this.state.expanded) {
      this.setState({
        expanded: false,
        activeToggle: false,
        noToggle: false
      });
    }
  }
  toggleExpanded = (0, _bind.default)(_context6 = this.toggleExpanded).call(_context6, this);
  toggleExpanded(ev = {}) {
    const {
      target
    } = ev;
    this.setState(prevState => {
      if (prevState.noToggle && prevState.expanded) {
        const activeToggle = prevState.expanded && target === this.toggleRef.current;
        if (prevState.activeToggle !== prevState.expanded && target === this.toggleRef.current) {
          return {
            activeToggle,
            focused: false
          };
        }
        return null;
      }
      return {
        activeToggle: !prevState.expanded && target === this.toggleRef.current,
        expanded: !prevState.expanded,
        focused: false
      };
    });
  }
  handleMouseDownOnOptions = (0, _bind.default)(_context7 = this.handleMouseDownOnOptions).call(_context7, this);
  handleMouseDownOnOptions() {
    this.mouseIsDownOnOptions = true;
  }
  handleMouseUpOnOptions = (0, _bind.default)(_context8 = this.handleMouseUpOnOptions).call(_context8, this);
  handleMouseUpOnOptions() {
    this.mouseIsDownOnOptions = false;
  }
  handleOnChange = (0, _bind.default)(_context9 = this.handleOnChange).call(_context9, this);
  handleOnChange(e) {
    const {
      options,
      intl,
      filterSuggestedOptions
    } = this.props;
    const {
      value: userEntry
    } = e.target;
    const suggestedOptions = getSuggestedOptions({
      filter: (0, _trim.default)(userEntry).call(userEntry),
      options,
      intl
    });
    if (filterSuggestedOptions) {
      this.setState({
        userEntry,
        expanded: userEntry.length >= 3 && suggestedOptions.length > 0,
        focused: true
      });
    } else {
      this.setState({
        userEntry,
        expanded: suggestedOptions.length > 0,
        focused: true
      });
    }
    this.props.onChange(userEntry);
  }
  handleOnClear = (0, _bind.default)(_context10 = this.handleOnClear).call(_context10, this);
  handleOnClear() {
    this.setState({
      userEntry: ''
    });
    this.props.onClear ? this.props.onClear('') : this.props.onChange('');
    clearTimeout(this._blurTimeout);
  }
  handleOnFocus = (0, _bind.default)(_context11 = this.handleOnFocus).call(_context11, this);
  handleOnFocus() {
    this.setState({
      activeToggle: false,
      expanded: false
    });
  }
  handleOnBlur = (0, _bind.default)(_context12 = this.handleOnBlur).call(_context12, this);
  handleOnBlur(ev) {
    const {
      options,
      selectOption,
      intl,
      disableSort
    } = this.props;
    const {
      value: userEntry
    } = ev.target;
    const sortedOptions = getSortedOptions({
      options,
      intl,
      disableSort
    });
    const selectedIndex = (0, _findIndex.default)(sortedOptions).call(sortedOptions, ({
      displayString
    }) => displayString === userEntry);
    const selection = selectedIndex > -1 ? sortedOptions[selectedIndex].val : userEntry;

    // allow selectOption to cancel onBlur effect
    this._blurTimeout = (0, _setTimeout2.default)(() => {
      selectOption(selection);
    }, 200);

    // This is needed to prevent options from collapsing when you're moving
    // from the `suggested options` to `all options` view. This happens when
    // you have a focused input field (and some suggestions are shown) and then
    // you click on a dropdown toggle. We don't want to hide the options
    // in this case. That's why we're temporarily set the `noToggle` property
    // to skip that behavior.
    this.setState({
      noToggle: true
    }, () => (0, _setTimeout2.default)(() => this.setState({
      noToggle: false
    }), 200));
  }
  handleOnKeyDown = (0, _bind.default)(_context13 = this.handleOnKeyDown).call(_context13, this);
  handleOnKeyDown(ev) {
    const {
      options,
      selectOption
    } = this.props;
    // let's reveal suggested/all options on arrow down
    if (ev.key === _constants.DOWN_KEY && !this.state.expanded && (0, _keys.default)(options).length > 0) {
      const suggestedOptions = getSuggestedOptions({
        filter: this.state.userEntry,
        options: this.props.options,
        intl: this.props.intl
      });

      /*
        when focused = `true`  - scoped suggestions will be shown
        when focused = `false` - all available options will be shown
       */
      this.setState({
        focused: suggestedOptions.length > 0,
        expanded: true
      });
    }
    // submit current user entry on Enter
    else if (ev.key === _constants.ENTER_KEY && this.props.allowTyping) {
      selectOption(this.state.userEntry);
    }
  }
  focus = (0, _bind.default)(_context14 = this.focus).call(_context14, this);
  focus() {
    this.inputRef.current.focus();
  }
  reset = (0, _bind.default)(_context15 = this.reset).call(_context15, this);
  reset() {
    clearTimeout(this._blurTimeout);
    this.setState({
      selection: '',
      userEntry: '',
      focused: false,
      expanded: false
    });
  }
  selectOption = (0, _bind.default)(_context16 = this.selectOption).call(_context16, this);
  selectOption(option) {
    const {
      val: selection,
      displayString,
      subTitle
    } = option;
    const {
      showSubTitle
    } = this.props;
    clearTimeout(this._blurTimeout);
    let handled = false;
    this.setState({
      userEntry: showSubTitle ? subTitle : displayString,
      expanded: false,
      activeToggle: false
    });
    if (typeof option.onClick === 'function') {
      // option.onClick handler should return "True", to skip the default handler
      handled = option.onClick(selection);
    }
    if (!handled) {
      this.props.selectOption(selection);
    }
  }
  render() {
    const {
      initialSelection,
      selection,
      allowTyping,
      createMode,
      intl,
      disableSort,
      hideToggle
    } = this.props;
    const {
      userEntry,
      expanded,
      focused
    } = this.state;
    let options = getSortedOptions({
      options: this.props.options,
      intl,
      disableSort
    });
    let suggestedOptions = [];
    if (allowTyping && focused) {
      // getSuggestedOptions uses memoized getSortedOptions
      suggestedOptions = getSuggestedOptions({
        options: this.props.options,
        filter: userEntry,
        intl
      });
    } else {
      suggestedOptions = options;
    }
    const disabled = this.props.disabled || !allowTyping && !options.length;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, this.props.className),
      onMouseDown: this.handleMouseDownOnOptions,
      onMouseUp: this.handleMouseUpOnOptions,
      ref: this.containerRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.selection
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      ref: this.inputRef,
      type: "text",
      name: "input",
      value: userEntry,
      modified: initialSelection && selection !== initialSelection,
      className: (0, _classnames.default)(styles.input, this.props.selectionClassName, {
        [styles.padded]: !disabled && !allowTyping
      }, {
        [styles.shifted]: this.state.activeToggle
      }),
      disabled: disabled,
      readOnly: !allowTyping,
      createMode: createMode,
      placeholder: expanded && this.props.expandedPlaceholder || this.props.placeholder,
      placeholderId: expanded && this.props.expandedPlaceholderId || this.props.placeholderId,
      showError: this.props.showError,
      error: this.props.error,
      errorClassName: this.props.errorClassName,
      onChange: this.handleOnChange,
      onClear: this.handleOnClear,
      onFocus: allowTyping ? this.handleOnFocus : _constants.NOOP,
      onBlur: allowTyping ? this.handleOnBlur : _constants.NOOP,
      onClick: !allowTyping ? this.toggleExpanded : _constants.NOOP,
      onKeyDown: allowTyping ? this.handleOnKeyDown : _constants.NOOP,
      showClear: this.props.showClear
    }), !hideToggle && /*#__PURE__*/_react.default.createElement(Toggle, {
      ref: this.toggleRef,
      active: this.state.activeToggle,
      disabled: this.props.disabled || !options.length,
      onClick: this.toggleExpanded,
      className: (0, _classnames.default)(this.props.toggleClassName, {
        [styles.mimic]: !allowTyping
      })
    })), expanded && Boolean(suggestedOptions.length) && /*#__PURE__*/_react.default.createElement(Ul, {
      className: this.props.optionsClassName,
      options: suggestedOptions,
      userEntry: userEntry,
      selection: selection,
      max: this.props.maxOptions || suggestedOptions.length,
      selectOption: this.selectOption,
      intl: intl,
      containerRef: this.containerRef,
      bufferTop: this.props.bufferTop,
      bufferBottom: this.props.bufferBottom,
      disableSort: disableSort,
      maxOptionsHeight: this.props.maxOptionsHeight,
      hint: this.props.hint
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(AuDropDown, {
  forwardRef: true
});